import YouTubeMediaUploadModal from './YouTubeMediaUploadModal';

export default YouTubeMediaUploadModal;
